import React from "react";
import theme from "@/styles/theme";
import {FormattedDate} from "react-intl";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {CardActionArea} from "@mui/material";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Link from "next/link";
import {grey} from "@mui/material/colors";
import {futuraNextCondensedExtraBold} from "@/styles/fonts";
import {StrapiImageAsset} from "@/components/StrapiImageAsset";

export const NewsIndexCard = ({article}) => {
    return (
        <Box sx={{display: {xs: "none", md: "block"}}}>
            <Card
                component={Link}
                href={`/news/${article.slug}`}
                elevation={0}
                sx={{
                    backgroundColor: theme.palette.common.white,
                    height: "100%",
                    textDecoration: "none",
                    "& .MuiCardActionArea-focusHighlight": {
                        backgroundColor: "transparent",
                    },
                }}
            >
                <CardActionArea disableRipple>
                    <Grid container spacing={3}>
                        <Grid item xs={4}>
                            <CardMedia
                                height="192"
                                sx={{
                                    bgcolor: grey[200],
                                    position: "relative",
                                    aspectRatio: "16/9",
                                }}
                            >
                                <StrapiImageAsset
                                    strapiImageObject={article?.image}
                                    layout="fill"
                                    width={400}
                                    height={225}
                                />
                            </CardMedia>
                        </Grid>
                        <Grid item xs={8}>
                            <CardContent
                                sx={{
                                    p: 0,
                                    "&.MuiCardContent-root": {
                                        "&:last-of-type": {
                                            paddingBottom: 0,
                                        },
                                    },
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    color="common.black"
                                    sx={{
                                        fontFamily: futuraNextCondensedExtraBold.style.fontFamily,
                                        mb: 1,
                                    }}
                                >
                                    {article.title}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: grey[500],
                                        display: "block",
                                        mb: 2,
                                    }}
                                >
                                    <FormattedDate
                                        value={
                                            article.date_display
                                                ? article.date_display
                                                : article.published_at
                                        }
                                    />
                                </Typography>
                                <Typography variant="body2">{article.teaser}</Typography>
                            </CardContent>
                        </Grid>
                    </Grid>
                </CardActionArea>
            </Card>
        </Box>
    );
};
